<template>
    <div class="mt-4 mb-2 ml-3">
        <div class="layout row mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Date:
            </div>
            <div>{{ row.scheduleDate | time }}</div>
        </div>
        <div class="layout row mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Created:
            </div>
            <div>{{ row.dateCreated | time }}</div>
        </div>

        <div class="layout row mb-2" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <div class="layout row mb-2">
            <div
                v-bind:class="{ 'text-danger': !row.isEnabled }"
                class="font-weight-medium mr-1 width-200"
            >
                Enebled:
            </div>
            <div v-bind:class="{ 'text-danger': !row.isEnabled }">
                {{ row.isEnabled ? "Yes" : "No" }}
            </div>
        </div>

        <div class="mt-5" v-if="row.details">
            <div class="font-weight-medium mb-2 layout row">
                Schedule Details
            </div>
            <div
                class="layout row mb-2"
                v-for="detail in getPaymentDetails()"
                v-if="row.details || row.scheduleDetails"
            >
                <div class="font-weight-medium mr-1">
                    {{ detail.category }}:
                </div>
                <div>${{ detail.amount }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function
    },
    data() {
        return {
            categories: new Map([
                ["TC", "Tuition"],
                ["TRNS", "Transportation"],
                ["LAPC", "Lapidus"]
            ])
        };
    },
    async created() {},
    computed: {},
    methods: {
        getPaymentDetails() {
            if (!this.row.details) return;

            const details = this.row.details
                ? this.row.details
                : this.row.scheduleDetails;

            return details.split("|").map(detail => {
                const category = detail.split(":")[0];
                const amount = detail.split(":")[1];

                return {
                    category: this.getCategoryName(category),
                    amount
                };
            });
        },
        getCategoryName(category) {
            return category == "TC"
                ? "Tuition"
                : category == "TRNS"
                ? "Transportation"
                : category;
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "details",
                    "dateCreated",
                    "scheduleDate",
                    "isEnabled",
                    "date"
                )
            )
                .map(key => {
                    const column = this.columns
                        .filter(c => !c.isIcon)
                        .find(c => c.field == key);

                    const value =
                        ["cancelDate", "lastUpdated", "processDate"].includes(
                            key
                        ) && this.row[key]
                            ? moment(this.row[key]).format(
                                  "MM/DD/YYYY h:mm:ss A"
                              )
                            : this.row[key];

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: value
                    };
                })
                .filter(p => p.value);
        }
    }
};
</script>
<style></style>
